import React from "react";

const steps = ["Create", "Requests", "Approved", "Conflict clearance", "Close req", "Closed"];

const MiniStepper = ({ currentStep }) => {
  const currentIndex = (currentStep || 1) - 1;
  const lineWidthPct = (currentIndex / (steps.length - 1)) * 100;

  return (
    <div className="w-full">
      <div style={{ position: "relative", height: "6px" }}>
        <div style={{ position: "absolute", top: "3px", left: "4px", right: "4px", height: "1px", background: "rgba(20,33,61,.18)" }} />
        <div style={{ position: "absolute", top: "3px", left: "4px", width: lineWidthPct + "%", height: "1px", background: "#8a6231" }} />
        {steps.map((step, i) => {
          const pct = (i / (steps.length - 1)) * 100;
          const isCurrent = i === currentIndex;
          const isDone = i < currentIndex;
          return (
            <div
              key={step}
              style={{
                position: "absolute",
                left: i === 0 ? 0 : i === steps.length - 1 ? "auto" : pct + "%",
                right: i === steps.length - 1 ? 0 : "auto",
                transform: i === 0 || i === steps.length - 1 ? "none" : "translateX(-50%)",
                top: 0,
                width: "6px",
                height: "6px",
                borderRadius: "50%",
                background: isCurrent ? "#8a6231" : isDone ? "#14213d" : "rgba(20,33,61,.3)",
              }}
            />
          );
        })}
      </div>
      <div style={{ position: "relative", height: "13px", marginTop: "7px" }}>
        {steps.map((step, i) => {
          const pct = (i / (steps.length - 1)) * 100;
          const isCurrent = i === currentIndex;
          const isEdge = i === 0 || i === steps.length - 1;
          return (
            <span
              key={step}
              style={{
                position: "absolute",
                left: i === steps.length - 1 ? "auto" : i === 0 ? 0 : pct + "%",
                right: i === steps.length - 1 ? 0 : "auto",
                transform: isEdge ? "none" : "translateX(-50%)",
                textAlign: i === steps.length - 1 ? "right" : i === 0 ? "left" : "center",
                width: isEdge ? "auto" : "64px",
                font: (isCurrent ? "500" : "400") + " 9.5px/1.3 'IBM Plex Sans',sans-serif",
                color: isCurrent ? "#14213d" : "rgba(20,33,61,.5)",
              }}
            >
              {step}
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default MiniStepper;
